import styles from '../SubscriptionPage.module.css';

const FAQ_ITEMS = [
  {
    question: 'What happens when I reach my daily limit?',
    answer: 'Once you reach your daily solve limit, you will need to wait until midnight UTC for your limit to reset, or upgrade to a higher tier for more solves.'
  },
  {
    question: 'Can I cancel my subscription anytime?',
    answer: 'Yes, you can cancel your subscription at any time. Your access will remain active until the end of your current billing period.'
  },
  {
    question: 'What payment methods do you accept?',
    answer: 'We accept all major credit cards and debit cards through our secure payment processor.'
  },
  {
    question: 'Do unused solves carry over to the next day?',
    answer: 'No, your daily solve limit resets at midnight UTC each day. Unused solves do not carry over.'
  }
];

export function FAQSection() {
  return (
    <div className={styles.faqSection}>
      <h2 className={styles.faqTitle}>Frequently Asked Questions</h2>
      <div className={styles.faqList}>
        {FAQ_ITEMS.map((item, idx) => (
          <div key={idx} className={styles.faqItem}>
            <h3 className={styles.faqQuestion}>{item.question}</h3>
            <p className={styles.faqAnswer}>{item.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
}